import { Component, Input, OnInit } from '@angular/core';
import { GrowthBookService } from '../../../core/services/growthbook.service';
import { RolesService } from '../../../core/services/roles/roles.service';
import { MenuItem, TooltipOptions } from 'primeng/api';
import { LicenseService } from '../../shared/services/license.service';
export interface RouteInfo {
  path: string;
  title: string;
  type: string;
  icontype: string;
  role: string | undefined;
  count: number;
}

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent
implements OnInit {

  public menuItems: MenuItem[];
  public count: number;
  @Input() isExpanded = true;

  tooltipOptions: TooltipOptions = {
    hideDelay: 150,
    showDelay: 300,
    tooltipEvent: 'hover',
    tooltipPosition: 'bottom'
  };

  constructor(
    public rolesService: RolesService,
    public licenseService: LicenseService,
    public growthBookService: GrowthBookService
  ) {
  }

  ngOnInit(): void {
    let availableMenuItems = [
      {
        routerLink: '/dashboard',
        disabled: !this.licenseService?.isLicenceUser(),
        label: 'navigationComponent.menuItems.dashboard',
        type: 'link',
        icon: 'icon-dashboard',
        role: 'nexcore_dashboard_view',
        count: -1,
      },
      {
        routerLink: '/my-tasks',
        disabled: !this.licenseService?.isLicenceUser(),
        label: 'navigationComponent.menuItems.myTasks',
        type: 'link',
        icon: 'icon-task',
        role: undefined,
        count: 0
      },
      {
        routerLink: 'tour-planner',
        disabled: !this.licenseService?.isLicenceUser(),
        label: 'navigationComponent.menuItems.tourPlanner',
        type: 'link',
        icon: 'icon-tour',
        role: 'nexcore_tour_view',
        count: -1,
      },
      {
        routerLink: '/assignment',
        disabled: !this.licenseService?.isLicenceUser(),
        label: 'navigationComponent.menuItems.assignment',
        type: 'link',
        icon: 'icon-taskplanner',
        role: 'nexcore_scheduling_view',
        count: 0
      },
      {
        routerLink: '/tasks',
        disabled: !this.licenseService?.isLicenceUser(),
        label: 'navigationComponent.menuItems.tasks',
        type: 'link',
        icon: 'icon-task-open',
        role: 'nexcore_task_view',
        count: 0
      },
      {
        routerLink: '/issues',
        disabled: !this.licenseService?.isLicenceUser(),
        label: 'Vorgänge',
        type: 'link',
        icon: 'icon-protocol-2',
        role: 'framework_issue_view',
        count: 0
      },
      {
        routerLink: 'orders',
        disabled: !this.licenseService?.isLicenceUser(),
        label: 'navigationComponent.menuItems.orders',
        type: 'link',
        icon: 'icon-order',
        role: 'nexcore_order_view',
        count: -1
      },
      {
        routerLink: '/customers',
        disabled: !this.licenseService?.isLicenceUser(),
        label: 'navigationComponent.menuItems.customers',
        type: 'link',
        icon: 'icon-group',
        role: 'nexcore_contact_view',
        count: -1
      },
      {
        routerLink: '/resources',
        disabled: !this.licenseService?.isLicenceUser(),
        label: 'navigationComponent.menuItems.resources',
        type: 'link',
        icon: 'icon-item',
        role: 'nexcore_resource_view',
        count: -1
      },
      {
        routerLink: '/articles',
        disabled: !this.licenseService?.isLicenceUser(),
        label: 'navigationComponent.menuItems.articles',
        type: 'link',
        icon: 'icon-article',
        role: 'nexcore_article_view',
        count: -1
      }
    ];

    this.menuItems = availableMenuItems.filter(item => {
      if(!item.role){
        return true;
      }
      return this.rolesService.hasRole(item.role);
    });
  }


}
